<template>
  <v-dialog width="620px" v-model="dialogDisplay">
    <v-card>
      <v-card-text>
        <div class="pt-4 d-flex justify-space-between">
          <div>
            <div>
              My wallet: {{userAccount}}
            </div>
            <div>
              Balance: {{stablecoinBalance / (10 ** paymentCoinDecimal)}} USDC
            </div>
            <div>
              Allowance to Decentral Store Contract: {{allowance / (10 ** paymentCoinDecimal)}} USDC
            </div>
          </div>
        </div>

        <v-divider class="mt-2"></v-divider>

        <v-stepper v-model="paymentStep" vertical elevation="0">
          <v-stepper-step
              :complete="paymentStep > 1"
              step="1"
              color="indigo darken-3"
              @click="paymentStep=1"
              class="cursor-pointer"
          >
            Approve payment fund
            <small class="mt-2">Decentral Store contract could transfer your stablecoin with your approved amount</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card color="grey lighten-3">
              <v-card-text>
                <div>Approval Amount: {{paymentAmount}}</div>
              </v-card-text>
            </v-card>

            <div class="text-right">
              <v-btn
                  color="indigo darken-3"
                  dark
                  small
                  class="mt-4"
                  :loading="approvalLoading"
                  @click="approveHandle"
              >
                Confirm
              </v-btn>
            </div>

          </v-stepper-content>

          <v-stepper-step
              step="2"
              :complete="paymentStep > 2"
              color="indigo darken-3"
              @click="paymentStep=2"
              class="cursor-pointer"
          >
            Payment
            <small class="mt-2">Pay to the store</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <slot name="paymentInfo" v-bind="{storeAccount, paymentAmount, remark, purchasableId}"></slot>
            <div class="text-right">
              <v-btn
                  v-if="!purchasableId"
                  class="mt-4"
                  color="indigo darken-3"
                  dark
                  small
                  :loading="paymentLoading"
                  @click="paymentHandle"
              >
                Confirm
              </v-btn>
              <v-btn
                  v-if="purchasableId"
                  class="mt-4"
                  color="indigo darken-3"
                  dark
                  small
                  :loading="paymentLoading"
                  @click="buyHandle"
              >
                Confirm
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper>
        <v-btn
            small
            depressed
            @click="dialogDisplay = false"
        >Close</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import store from "@/store";
import ethCall from "@/lib/eth/ethCall";
import ethUtil from "@/lib/eth/util"
import Vue from 'vue'
import config from "@/config";

export default {
  name: "PaymentDialog",
  props: {
    storeAccount: String,
    paymentAmount: String,
    remark: String, //account payment
    purchasableId: String, //purchase item
  },
  computed: {
    userAccount(){
      return store.state.loggedInAccount
    },
    paymentCoinDecimal() {
      return config.commonConfig.paymentCoinDecimal
    }
  },
  mounted() {
    this.dialogDisplay = true
    ethCall.paymentErc20.getBalance(store.state.loggedInAccount).then((balance) => {
      this.stablecoinBalance = balance
    })
    ethCall.paymentErc20.getAllowance(store.state.loggedInAccount).then((allowance) => {
      this.allowance = allowance
    })
  },
  watch: {
    dialogDisplay(display) {
      if (display === false) {
        store.state.paymentDialogShow = false
      }
    }
  },
  data(){
    return {
      stablecoinBalance: null,
      allowance: null,
      dialogDisplay: false,
      paymentStep: 1,
      approvalLoading: false,
      paymentLoading: false,
      selectedRewardeeOption: "Current Account",
      rewardeeOptions: ["Current Account", "Other Account"],
    }
  },
  methods: {
    async approveHandle() {
      try {
        this.approvalLoading = true
        const paymentAmount = this.paymentAmount * (10 ** this.paymentCoinDecimal)
        await ethCall.paymentErc20.approve(paymentAmount)
        this.allowance = paymentAmount
        Vue.notify({
          type: "success",
          text: `Success to approve Decentral Store smart contract using of ${this.paymentAmount} USDC`
        })
        this.paymentStep += 1
      } catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }
        console.error(e)
      } finally {
        this.approvalLoading = false
      }
    },
    async paymentHandle() {
      const memo = JSON.stringify({
        remark: this.remark
      })

      try {
        this.paymentLoading = true
        await ethCall.storeFactory.storePayment(this.storeAccount, this.paymentAmount * (10 ** this.paymentCoinDecimal), memo)
        this.paymentStep += 1
        Vue.notify({type: 'success', text: 'Payment Success'})
        this.dialogDisplay = false
      } catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }
      console.error(e)
      } finally {
        this.paymentLoading = false
      }
    },

    async buyHandle(){
      try {
        this.paymentLoading = true
        await ethCall.storeFactory.buyPurchasable(this.storeAccount, this.purchasableId, 1)
        this.paymentStep += 1
        Vue.notify({type: 'success', text: 'Item purchase success'})
      } catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }
      } finally {
        this.paymentLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>